// extracted by mini-css-extract-plugin
export default {"wrapper":"hubNavigationFocus__wrapper__HrMob","logo":"hubNavigationFocus__logo__axQEq"};